import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { formatCompactAmount } from "../api/DataTypeUtils";

const AmountField = ({ amount }) => {
  const { i18n } = useTranslation();

  const projectCurrency = useSelector((state: any) =>
    state.projectReducer.getIn(["project", "currency"])
  );

  const [currency, setCurrency] = useState(projectCurrency);

  useEffect(() => {
    setCurrency(projectCurrency);
  }, [projectCurrency]);

  const value = parseFloat(amount);

  if (value && value > 0) {
    return formatCompactAmount(i18n.language, amount, currency);
  }
  return null;
};

export default AmountField;
